module.exports = "/packs/images/homepage/facilities/soft-play~58aa0eef5617cf53a98a5477acae64c3.jpg";